import video from "../../assets/home/eleva-espacio-video.mp4"
function Elevaespacio() {

    return (
        <section className="eleva-main-container">
            <section className="eleva-container">
                <div className="eleva-column1">
                    <h2>Y CREA ESPACIOS MODERNOS</h2>
                    <span className="line"></span>
                    <div className="description">
                        <p>
                            Una amplia variedad de
                            opciones para transformar tus
                            espacios, con aplicaciones
                            que van del interior al exterior
                            y se adaptan a cada proyecto.
                        </p>
                    </div>
                </div>
                <div>
                    <div className="title-container">
                        <h2>ELEVA TU ESPACIO</h2>
                    </div>
                    <video
                        autoPlay
                        muted
                        loop
                        src={video}
                        type="video/mp4"
                    />
                </div>



            </section>

        </section>
    );
}

export default Elevaespacio;